
import AppConstants from '../config/app.constants';

let BypassCodeService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/bypass-code-usage`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/bypass-code-usage/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let generateBypassCode = (codeType, branchId, routeId, userId, vaultDate, locationId) => {
        return $http
            .get(AppConstants.api + `/bypass-code-usage/generate-bypass-code`, {
                params: {
                    codeType,
                    branchId,
                    routeId,
                    userId,
                    vaultDate,
                    locationId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let closeLock = (data) => {
        return $http
            .post(AppConstants.api + `/bypass-code-usage/close-lock`, data)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        generateBypassCode,
        closeLock
    };
}

BypassCodeService.$inject = ['$http', '$q']

export default BypassCodeService;


// WEBPACK FOOTER //
// ./client/app/services/bypass-code.service.js